import { INSTANCE_ID } from '~/constants';
import FelgueirasCoFinancingLogo from '../svg/logos/co-financing/felgueiras';
import DefaultCoFinancingLogo from '../svg/logos/co-financing/default';
import MonchiqueCoFinancingLogo from '../svg/logos/co-financing/monchique';
import AmbiOlhaoCoFinancingLogo from '../svg/logos/co-financing/ambiolhao';
import AqlaraCoFinancingLogo from '../svg/logos/co-financing/aqlara';

export default function CoFinancingLogo({
    className = '',
}: {
    className?: string;
}) {
    return (
        <div className="flex h-auto w-full">
            {INSTANCE_ID === 152 && (
                <AmbiOlhaoCoFinancingLogo className={className} />
            )}
            {INSTANCE_ID === 253 && (
                <FelgueirasCoFinancingLogo className={className} />
            )}
            {INSTANCE_ID === 353 && (
                <MonchiqueCoFinancingLogo className={className} />
            )}
            {[371, 370].includes(INSTANCE_ID) && (
                <AqlaraCoFinancingLogo className={className} />
            )}
            {[
                130, 164, 174, 202, 205, 206, 207, 208, 209, 210, 211, 212, 213,
                214, 199, 163, 227, 193,
            ].includes(INSTANCE_ID) && (
                <DefaultCoFinancingLogo className={className} />
            )}
        </div>
    );
}
